"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Event = void 0;
var _excluded = ["chat", "accountId", "error"];
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Event = exports.Event = {
  CLICK: 'click',
  VIEW: 'view',
  STATISTICS: 'statistics',
  ERROR: 'error',
  LOAD: 'load',
  SUCCESS: 'success',
  IMPRESSION: 'impression'
};
var _process$env$NODE_ENV = "production",
  NODE_ENV = _process$env$NODE_ENV === void 0 ? 'development' : _process$env$NODE_ENV;
var isDevelopment = NODE_ENV === 'development';
var buildWebPayload = function buildWebPayload(event, objectDetail, topLevel, extra) {
  return _objectSpread(_objectSpread({
    event_type: event,
    object_detail: objectDetail,
    last_bump_age_secs: window.dataLayer && window.dataLayer[0] && window.dataLayer[0].page && window.dataLayer[0].page.detail && window.dataLayer[0].page.detail.last_bump_age_secs
  }, topLevel), extra);
};
var send = function send(event, objectDetail, params) {
  var extra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var payload = buildWebPayload(event, objectDetail, params, extra);
  if (isDevelopment) {
    console.log('Lurker: ', payload); // eslint-disable-line no-console
    return;
  }

  // Lurker will send all events in this list when the script finishes loading
  if (!window.Lurker) {
    window.beforeLurkerLoadEvents = window.beforeLurkerLoadEvents || [];
    window.beforeLurkerLoadEvents.push(payload);
    return;
  }
  window.Lurker.send(payload)["catch"](console.error); // eslint-disable-line no-console
};
var sendAsBeacon = function sendAsBeacon(event, objectDetail, topLevel, extra) {
  var payload = buildWebPayload(event, objectDetail, topLevel, extra);
  if (isDevelopment) {
    console.log('Lurker: ', payload); // eslint-disable-line no-console
    return;
  }
  if (window.Lurker && window.Lurker.sendOnUnload) {
    window.Lurker.sendOnUnload(function () {
      return payload;
    });
  }
};
var Lurker = /*#__PURE__*/function () {
  function Lurker(chat, accountId, listId, version, renderProps) {
    _classCallCheck(this, Lurker);
    var objectName = listId ? 'item_page' : 'chat';
    Object.assign(this, {
      chat: chat,
      accountId: accountId,
      objectName: objectName,
      renderProps: renderProps,
      version: version
    });
  }
  return _createClass(Lurker, [{
    key: "clickActionButton",
    value:
    // action buttons
    function clickActionButton(objectDetails) {
      this.prepareDataAndSend(Event.CLICK, objectDetails, {});
    }
  }, {
    key: "viewActionButton",
    value: function viewActionButton(objectDetails) {
      this.prepareDataAndSend(Event.VIEW, objectDetails, {});
    }
  }, {
    key: "viewNegotiationOfferReview",
    value: function viewNegotiationOfferReview() {
      this.prepareDataAndSend(Event.VIEW, 'negotiation_offer_review');
    }
  }, {
    key: "clickNegotiationOfferReviewClose",
    value: function clickNegotiationOfferReviewClose() {
      this.prepareDataAndSend(Event.CLICK, 'negotiation_offer_review_close');
    }
  }, {
    key: "clickNegotiationOfferReviewReject",
    value: function clickNegotiationOfferReviewReject() {
      this.prepareDataAndSend(Event.CLICK, 'negotiation_offer_review_reject');
    }
  }, {
    key: "clickNegotiationOfferReviewRejectSuccess",
    value: function clickNegotiationOfferReviewRejectSuccess() {
      this.prepareDataAndSend(Event.SUCCESS, 'negotiation_offer_review_reject');
    }
  }, {
    key: "clickNegotiationOfferReviewAccept",
    value: function clickNegotiationOfferReviewAccept() {
      this.prepareDataAndSend(Event.CLICK, 'negotiation_offer_review_approve');
    }
  }, {
    key: "clickNegotiationOfferReviewAcceptSuccess",
    value: function clickNegotiationOfferReviewAcceptSuccess() {
      this.prepareDataAndSend(Event.SUCCESS, 'negotiation_offer_review_approve');
    }
  }, {
    key: "clickSendNegotiationOffer",
    value: function clickSendNegotiationOffer() {
      this.prepareDataAndSend(Event.CLICK, 'send_negotiation_offer');
    }
  }, {
    key: "clickSendNegotiationOfferClose",
    value: function clickSendNegotiationOfferClose() {
      this.prepareDataAndSend(Event.CLICK, 'send_negotiation_offer_close');
    }
  }, {
    key: "clickSendNegotiationOfferSuccess",
    value: function clickSendNegotiationOfferSuccess() {
      this.prepareDataAndSend(Event.SUCCESS, 'send_negotiation_offer');
    }
  }, {
    key: "impressionDisputeModalFeedback",
    value: function impressionDisputeModalFeedback(isSeller) {
      this.prepareDataAndSend(Event.IMPRESSION, 'dispute_modal_feedback', {
        object_name: isSeller ? 'olx_pay_seller_order_details' : 'olx_pay_buyer_order_details'
      });
    }
  }, {
    key: "clickDisputeModalFeedbackClose",
    value: function clickDisputeModalFeedbackClose(isSeller) {
      this.prepareDataAndSend(Event.CLICK, 'dispute_close_modal_feedback', {
        object_name: isSeller ? 'olx_pay_seller_order_details' : 'olx_pay_buyer_order_details'
      });
    }
  }, {
    key: "clickDisputeModalFeedbackSend",
    value: function clickDisputeModalFeedbackSend(isSeller) {
      this.prepareDataAndSend(Event.CLICK, 'dispute_deal_close_chat', {
        object_name: isSeller ? 'olx_pay_seller_order_details' : 'olx_pay_buyer_order_details'
      });
    }
  }, {
    key: "clickAskProfileVerification",
    value: function clickAskProfileVerification(chatId, accountId) {
      this.prepareDataAndSend(Event.CLICK, 'click_ask_profile_verification', {
        chat_id: chatId,
        account_id: accountId
      });
    }
  }, {
    key: "showAlreadySoldTip",
    value: function showAlreadySoldTip() {
      this.prepareDataAndSend(Event.VIEW, 'already_sold_tip');
    }
  }, {
    key: "clickChatList",
    value: function clickChatList(isFavorite) {
      this.prepareDataAndSend(Event.CLICK, 'chat_list');
      if (isFavorite) {
        this.prepareDataAndSend(Event.CLICK, 'chat_list', {
          data: 'previous_favorite_tab'
        });
      }
    }
  }, {
    key: "viewChatListSuccessful",
    value: function viewChatListSuccessful(isFavorite) {
      this.prepareDataAndSend(Event.VIEW, 'chat_list_successful');
      if (isFavorite) {
        this.prepareDataAndSend(Event.VIEW, 'chat_list_successful', {
          data: 'previous_favorite_tab'
        });
      }
    }
  }, {
    key: "viewChatListFailure",
    value: function viewChatListFailure() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
      var isFavorite = arguments.length > 1 ? arguments[1] : undefined;
      this.prepareDataAndSend(Event.VIEW, 'chat_list_failure', {
        error: error
      });
      if (isFavorite) {
        this.prepareDataAndSend(Event.VIEW, 'chat_list_failure', {
          error: error,
          data: 'previous_favorite_tab'
        });
      }
    }
  }, {
    key: "autoLoadChatsError",
    value: function autoLoadChatsError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
      this.prepareDataAndSend(Event.VIEW, 'auto_load_chats_error', {
        error: error
      });
    }
  }, {
    key: "viewChatListWithNotLoggedUser",
    value: function viewChatListWithNotLoggedUser() {
      this.prepareDataAndSend(Event.VIEW, 'chat_list_with_unlogged_user');
    }
  }, {
    key: "clickOpenChatMessages",
    value: function clickOpenChatMessages(isFavorite) {
      this.prepareDataAndSend(Event.CLICK, 'open_chat_messages');
      if (isFavorite) {
        this.prepareDataAndSend(Event.CLICK, 'open_chat_messages', {
          data: 'previous_favorite_tab'
        });
      }
    }
  }, {
    key: "viewOpenChatMessagesSuccessful",
    value: function viewOpenChatMessagesSuccessful(microsecondDiff, chatListPosition, isFavorite) {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_messages_successful', {
        microsecond_diff: microsecondDiff,
        chat_list_position: chatListPosition || 'undefined'
      });
      if (isFavorite) {
        this.prepareDataAndSend(Event.VIEW, 'open_chat_messages_successful', {
          microsecond_diff: microsecondDiff,
          chat_list_position: chatListPosition || 'undefined',
          data: 'previous_favorite_tab'
        });
      }
    }
  }, {
    key: "viewOpenChatMessagesFailure",
    value: function viewOpenChatMessagesFailure(error, microsecondDiff, chatListPosition, isFavorite) {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_messages_failure', {
        error: error,
        microsecond_diff: microsecondDiff,
        chat_list_position: chatListPosition || 'undefined'
      });
      if (isFavorite) {
        this.prepareDataAndSend(Event.VIEW, 'open_chat_messages_failure', {
          error: error,
          microsecond_diff: microsecondDiff,
          chat_list_position: chatListPosition || 'undefined',
          data: 'previous_favorite_tab'
        });
      }
    }
  }, {
    key: "viewOpenChatMessagesWithBannedUser",
    value: function viewOpenChatMessagesWithBannedUser() {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_messages_with_banned_user');
    }
  }, {
    key: "viewOpenChatMessagesWithBlockedUser",
    value: function viewOpenChatMessagesWithBlockedUser() {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_messages_with_blocked_user');
    }
  }, {
    key: "viewOpenChatMessagesOnExpiredAd",
    value: function viewOpenChatMessagesOnExpiredAd() {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_messages_on_expired_ad');
    }
  }, {
    key: "viewOpenChatMessagesWithUserWithChatDisabled",
    value: function viewOpenChatMessagesWithUserWithChatDisabled() {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_messages_with_user_with_chat_disabled');
    }
  }, {
    key: "viewOpenChatMessagesWithNoInternet",
    value: function viewOpenChatMessagesWithNoInternet() {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_messages_with_no_internet');
    }

    // Open chat events on ad view page
  }, {
    key: "viewOpenChatSuccessful",
    value: function viewOpenChatSuccessful(chat, microsecondDiff) {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_successful', {
        chat: chat,
        microsecond_diff: microsecondDiff
      });
    }
  }, {
    key: "viewOpenChatFailure",
    value: function viewOpenChatFailure(chat, error, microsecondDiff) {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_failure', {
        chat: chat,
        error: error,
        microsecond_diff: microsecondDiff
      });
    }
  }, {
    key: "viewOpenChatWithBannedUser",
    value: function viewOpenChatWithBannedUser(chat) {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_with_banned_user', {
        chat: chat
      });
    }
  }, {
    key: "viewOpenChatWithValidatingProfileUser",
    value: function viewOpenChatWithValidatingProfileUser(chat) {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_with_validating_profile_user', {
        chat: chat
      });
    }
  }, {
    key: "viewOpenChatWithBlockedUser",
    value: function viewOpenChatWithBlockedUser(chat) {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_with_blocked_user', {
        chat: chat
      });
    }
  }, {
    key: "viewOpenChatOnExpiredAd",
    value: function viewOpenChatOnExpiredAd(chat) {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_on_expired_ad', {
        chat: chat
      });
    }
  }, {
    key: "viewOpenChatWithUserWithChatDisabled",
    value: function viewOpenChatWithUserWithChatDisabled(chat) {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_with_user_with_chat_disabled', {
        chat: chat
      });
    }
  }, {
    key: "viewOpenChatWithUnverifiedPhone",
    value: function viewOpenChatWithUnverifiedPhone(chat) {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_with_unverified_phone', {
        chat: chat
      });
    }
  }, {
    key: "viewOpenChatWithNoInternet",
    value: function viewOpenChatWithNoInternet(chat) {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_with_no_internet', {
        chat: chat
      });
    }
  }, {
    key: "viewOpenChatWithNotLoggedUser",
    value: function viewOpenChatWithNotLoggedUser() {
      this.prepareDataAndSend(Event.VIEW, 'open_chat_with_unlogged_user');
    }

    // Send message events
  }, {
    key: "clickSendMessage",
    value: function clickSendMessage(id, isFavorite) {
      this.prepareDataAndSend(Event.CLICK, 'send_message', {
        message_id: id
      });
      if (isFavorite) {
        this.prepareDataAndSend(Event.CLICK, 'send_message', {
          message_id: id,
          data: 'previous_favorite_tab'
        });
      }
    }
  }, {
    key: "clickSendImage",
    value: function clickSendImage(url, id) {
      this.prepareDataAndSend(Event.CLICK, 'send_image', {
        url: url,
        message_id: id
      });
    }
  }, {
    key: "clickOpenChatAdView",
    value: function clickOpenChatAdView() {
      this.prepareDataAndSend(Event.CLICK, 'open_chat');
      this.prepareDataAndSend(Event.CLICK, 'open_chat', {
        object_name: 'upr_adview_profile_component'
      });
    }
  }, {
    key: "viewSendImageSuccessful",
    value: function viewSendImageSuccessful(id, isFavorite) {
      this.prepareDataAndSend(Event.VIEW, 'send_image_successful', {
        message_id: id
      });
      if (isFavorite) {
        this.prepareDataAndSend(Event.VIEW, 'send_image_successful', {
          message_id: id,
          data: 'previous_favorite_tab'
        });
      }
    }
  }, {
    key: "viewSendMessageSuccessful",
    value: function viewSendMessageSuccessful(id, isFavorite) {
      this.prepareDataAndSend(Event.VIEW, 'send_message_successful', {
        message_id: id
      });
      if (isFavorite) {
        this.prepareDataAndSend(Event.VIEW, 'send_message_successful', {
          message_id: id,
          data: 'previous_favorite_tab'
        });
      }
    }
  }, {
    key: "viewSendBuyerFirstMessageSuccessful",
    value: function viewSendBuyerFirstMessageSuccessful(id, isInitialMessage) {
      this.prepareDataAndSend(Event.VIEW, 'send_buyer_first_message_successful', {
        message_id: id,
        is_initial_message: isInitialMessage
      });
    }
  }, {
    key: "viewInitialMessage",
    value: function viewInitialMessage() {
      this.prepareDataAndSend(Event.VIEW, 'initial_message');
    }
  }, {
    key: "viewSendImageFailure",
    value: function viewSendImageFailure(id, error) {
      this.prepareDataAndSend(Event.VIEW, 'send_image_failure', {
        message_id: id,
        error: error
      });
    }
  }, {
    key: "viewSendMessageFailure",
    value: function viewSendMessageFailure(id, error, isFavorite) {
      this.prepareDataAndSend(Event.VIEW, 'send_message_failure', {
        message_id: id,
        error: error
      });
      if (isFavorite) {
        this.prepareDataAndSend(Event.VIEW, 'send_message_failure', {
          message_id: id,
          data: 'previous_favorite_tab'
        });
      }
    }
  }, {
    key: "viewSendMessageToBannedUser",
    value: function viewSendMessageToBannedUser(id) {
      this.prepareDataAndSend(Event.VIEW, 'send_message_to_banned_user', {
        message_id: id
      });
    }
  }, {
    key: "viewSendMessageToBlockedUser",
    value: function viewSendMessageToBlockedUser(id) {
      this.prepareDataAndSend(Event.VIEW, 'send_message_to_blocked_user', {
        message_id: id
      });
    }
  }, {
    key: "viewSendMessageWithNoInternet",
    value: function viewSendMessageWithNoInternet(id) {
      this.prepareDataAndSend(Event.VIEW, 'send_message_with_no_internet', {
        message_id: id
      });
    }
  }, {
    key: "viewReplyChatFirstTime",
    value: function viewReplyChatFirstTime(id, timeDiffInMs, isFavorite) {
      this.prepareDataAndSend(Event.VIEW, 'reply_chat_first_time', {
        message_id: id,
        diff: timeDiffInMs
      });
      if (isFavorite) {
        this.prepareDataAndSend(Event.VIEW, 'reply_chat_first_time', {
          message_id: id,
          diff: timeDiffInMs,
          data: 'previous_favorite_tab'
        });
      }
    }
  }, {
    key: "viewReplyChat",
    value: function viewReplyChat(id, timeDiffInMs, isBuyer, isFavorite) {
      var userType = isBuyer ? 'buyer' : 'seller';
      this.prepareDataAndSend(Event.VIEW, "".concat(userType, "_reply_chat"), {
        message_id: id,
        diff: timeDiffInMs
      });
      if (isFavorite) {
        this.prepareDataAndSend(Event.VIEW, "".concat(userType, "_reply_chat"), {
          message_id: id,
          diff: timeDiffInMs,
          data: 'previous_favorite_tab'
        });
      }
    }
  }, {
    key: "clickPreDefinedMessage",
    value: function clickPreDefinedMessage(message, isFavorite) {
      this.prepareDataAndSend(Event.CLICK, 'pre_defined_message', {
        message: message
      });
      if (isFavorite) {
        this.prepareDataAndSend(Event.CLICK, 'pre_defined_message', {
          message: message,
          data: 'previous_favorite_tab'
        });
      }
    }
  }, {
    key: "clickInitialPreDefinedMessage",
    value: function clickInitialPreDefinedMessage(message) {
      this.prepareDataAndSend(Event.CLICK, 'initial_predefined_message', {
        message: message
      });
    }

    // Delete chat events
  }, {
    key: "clickDeleteChat",
    value: function clickDeleteChat() {
      this.prepareDataAndSend(Event.CLICK, 'delete_chat');
    }
  }, {
    key: "viewDeleteChatSuccessful",
    value: function viewDeleteChatSuccessful(isFavorite) {
      this.prepareDataAndSend(Event.VIEW, 'delete_chat_successful');
      if (isFavorite) {
        this.prepareDataAndSend(Event.VIEW, 'delete_chat_successful', {
          data: 'previous_favorite_tab'
        });
      }
    }
  }, {
    key: "viewDeleteChatFailure",
    value: function viewDeleteChatFailure(error) {
      this.prepareDataAndSend(Event.VIEW, 'delete_chat_failure', {
        error: error
      });
    }
  }, {
    key: "viewDeleteWithNoInternet",
    value: function viewDeleteWithNoInternet() {
      this.prepareDataAndSend(Event.VIEW, 'delete_chat_with_no_internet');
    }

    // Block user chat events
  }, {
    key: "clickBlockUserChat",
    value: function clickBlockUserChat() {
      this.prepareDataAndSend(Event.CLICK, 'block_user_chat');
    }
  }, {
    key: "viewBlockUserSuccessful",
    value: function viewBlockUserSuccessful() {
      this.prepareDataAndSend(Event.VIEW, 'block_user_chat_successful');
    }
  }, {
    key: "viewBlockUserFailure",
    value: function viewBlockUserFailure(error) {
      this.prepareDataAndSend(Event.VIEW, 'block_user_chat_failure', {
        error: error
      });
    }
  }, {
    key: "viewBlockUserWithNoInternet",
    value: function viewBlockUserWithNoInternet() {
      this.prepareDataAndSend(Event.VIEW, 'block_user_with_no_internet');
    }

    // Unblock user chat events
  }, {
    key: "clickUnblockUser",
    value: function clickUnblockUser() {
      this.prepareDataAndSend(Event.CLICK, 'unblock_user_chat');
    }
  }, {
    key: "viewUnblockUserSuccessful",
    value: function viewUnblockUserSuccessful() {
      this.prepareDataAndSend(Event.VIEW, 'unblock_user_chat_successful');
    }
  }, {
    key: "viewUnblockUserFailure",
    value: function viewUnblockUserFailure(error) {
      this.prepareDataAndSend(Event.VIEW, 'unblock_user_chat_failure', {
        error: error
      });
    }
  }, {
    key: "viewUnblockUserWithNoInternet",
    value: function viewUnblockUserWithNoInternet() {
      this.prepareDataAndSend(Event.VIEW, 'unblock_user_with_no_internet');
    }

    // Report user chat events
  }, {
    key: "clickReportUserChat",
    value: function clickReportUserChat(reportType) {
      this.prepareDataAndSend(Event.CLICK, 'report_user_chat', {
        type: reportType
      });
    }
  }, {
    key: "viewReportUserSuccessful",
    value: function viewReportUserSuccessful(reason, reportType) {
      this.prepareDataAndSend(Event.VIEW, 'report_user_chat_successful', {
        reason: reason,
        type: reportType
      });
    }
  }, {
    key: "viewReportUserFailure",
    value: function viewReportUserFailure(reason, error, reportType) {
      this.prepareDataAndSend(Event.VIEW, 'report_user_chat_failure', {
        reason: reason,
        error: error,
        type: reportType
      });
    }
  }, {
    key: "viewReportUserWithNoInternet",
    value: function viewReportUserWithNoInternet(reason, reportType) {
      this.prepareDataAndSend(Event.VIEW, 'report_user_chat_with_no_internet', {
        reason: reason,
        type: reportType
      });
    }

    // Control events
  }, {
    key: "viewConnectionError",
    value: function viewConnectionError(error) {
      this.prepareDataAndSend(Event.VIEW, 'connection_error', {
        error: error
      });
    }
  }, {
    key: "unhandledError",
    value: function unhandledError(error) {
      this.prepareDataAndSend(Event.ERROR, 'unhandled_error', {
        error: error
      });
    }

    // Image upload events
  }, {
    key: "clickImageUploadCTA",
    value: function clickImageUploadCTA(imageUploadType) {
      this.prepareDataAndSend(Event.CLICK, 'flag_send_image', {
        imageUploadType: imageUploadType
      });
    }
  }, {
    key: "clickBackImageUpload",
    value: function clickBackImageUpload() {
      this.prepareDataAndSend(Event.CLICK, 'back_send_image');
    }
  }, {
    key: "imageUploadStarted",
    value: function imageUploadStarted(imageId) {
      this.prepareDataAndSend(Event.VIEW, 'image_upload', {
        imageId: imageId
      });
    }
  }, {
    key: "imageUploadSuccessful",
    value: function imageUploadSuccessful(imageId) {
      this.prepareDataAndSend(Event.VIEW, 'image_upload_successful', {
        imageId: imageId
      });
    }
  }, {
    key: "imageUploadFailed",
    value: function imageUploadFailed(imageId, error) {
      this.prepareDataAndSend(Event.VIEW, 'image_upload_failure', {
        imageId: imageId,
        error: error
      });
    }
  }, {
    key: "openImageClick",
    value: function openImageClick(imageSource) {
      this.prepareDataAndSend(Event.CLICK, 'open_image', {
        imageSource: imageSource
      });
    }

    // Tip events
  }, {
    key: "viewOutOfSyncMessages",
    value: function viewOutOfSyncMessages() {
      this.prepareDataAndSend(Event.VIEW, 'out_of_sync_messages');
    }
  }, {
    key: "viewSecurityBox",
    value: function viewSecurityBox(amISeller, tipOptions) {
      this.prepareDataAndSend(Event.CLICK, 'see_chat_security_box', _objectSpread({
        is_buyer: !amISeller
      }, tipOptions));
    }
  }, {
    key: "clickTipFeedback",
    value: function clickTipFeedback(selectedOption, tipOptions) {
      this.prepareDataAndSend(Event.CLICK, 'tip_feedback', _objectSpread({
        selectedOption: selectedOption
      }, tipOptions));
    }
  }, {
    key: "clickCloseChat",
    value: function clickCloseChat() {
      this.prepareDataAndSend(Event.CLICK, 'close_chat');
    }
  }, {
    key: "clickViewUserProfile",
    value: function clickViewUserProfile() {
      this.prepareDataAndSend(Event.CLICK, 'view_user_profile');
    }
  }, {
    key: "clickViewUserProfileFromAd",
    value: function clickViewUserProfileFromAd() {
      this.prepareDataAndSend(Event.CLICK, 'view_user_profile_from_ad');
    }
  }, {
    key: "clickLoginButton",
    value: function clickLoginButton() {
      this.prepareDataAndSendAsBeacon(Event.CLICK, 'chat_login_button');
    }

    // Modal Tip Security
  }, {
    key: "clickRating",
    value: function clickRating(event_type, object_name, object_detail, data) {
      this.prepareDataAndSend(event_type, object_detail, {
        data: data
      });
    }
  }, {
    key: "clickCloseSecurityTipModal",
    value: function clickCloseSecurityTipModal(event_type, object_name, object_detail, data) {
      this.prepareDataAndSend(event_type, object_detail, {
        data: data
      });
    }
  }, {
    key: "viewSecurityTipModal",
    value: function viewSecurityTipModal(event_type, object_name, object_detail, data) {
      this.prepareDataAndSend(event_type, object_detail, {
        data: data
      });
    }
    // Favorite Chat
  }, {
    key: "viewFavorite",
    value: function viewFavorite() {
      this.prepareDataAndSend(Event.VIEW, 'favorite_successful');
    }
  }, {
    key: "viewFavoriteFailure",
    value: function viewFavoriteFailure() {
      this.prepareDataAndSend(Event.VIEW, 'favorite_failure');
    }
  }, {
    key: "selectFavorite",
    value: function selectFavorite() {
      this.prepareDataAndSend(Event.CLICK, 'favorite_select');
    }
  }, {
    key: "unselectFavorite",
    value: function unselectFavorite() {
      this.prepareDataAndSend(Event.CLICK, 'favorite_unselect');
    }

    // Foi removido?
  }, {
    key: "selectFavoriteError",
    value: function selectFavoriteError() {
      this.prepareDataAndSend(Event.CLICK, 'favorite_select_error');
    }

    // Foi removido?
  }, {
    key: "unselectFavoriteError",
    value: function unselectFavoriteError() {
      this.prepareDataAndSend(Event.CLICK, 'favorite_unselect_error');
    }
  }, {
    key: "onboardingFavorite",
    value: function onboardingFavorite() {
      this.prepareDataAndSend(Event.VIEW, 'tooltip_onboarding_favorite');
    }
  }, {
    key: "closeOnboardingFavorite",
    value: function closeOnboardingFavorite() {
      this.prepareDataAndSend(Event.CLICK, 'close_tooltip_onboarding_favorite');
    }
  }, {
    key: "clickTabFavorite",
    value: function clickTabFavorite() {
      this.prepareDataAndSend(Event.CLICK, 'tab_favorite');
    }
  }, {
    key: "clickAllTab",
    value: function clickAllTab() {
      this.prepareDataAndSend(Event.CLICK, 'back_tab_todas', {
        data: 'previous_favorite_tab'
      });
    }

    // TODO redundant word `see` in the event name
  }, {
    key: "viewSeeOptionsChat",
    value: function viewSeeOptionsChat() {
      this.prepareDataAndSend(Event.VIEW, 'see_options_chat');
    }
  }, {
    key: "clickAdviceInsertAd",
    value: function clickAdviceInsertAd() {
      this.prepareDataAndSend(Event.CLICK, 'advice_insert_ad');
    }
  }, {
    key: "clickTipAction",
    value: function clickTipAction(params) {
      this.prepareDataAndSend(Event.CLICK, 'tip_action', params);
    }
  }, {
    key: "myShoppingTabClick",
    value: function myShoppingTabClick() {
      send(Event.CLICK, 'tab_minhas_compras');
    }
  }, {
    key: "myShoppingTabView",
    value: function myShoppingTabView() {
      send(Event.VIEW, 'tab_minhas_compras');
    }
  }, {
    key: "mySalesTabClick",
    value: function mySalesTabClick() {
      send(Event.CLICK, 'tab_minhas_vendas');
    }
  }, {
    key: "mySalesTabView",
    value: function mySalesTabView() {
      send(Event.VIEW, 'tab_minhas_vendas');
    }
  }, {
    key: "archivedTabClick",
    value: function archivedTabClick() {
      send(Event.CLICK, 'tab_arquivadas');
    }
  }, {
    key: "archivedTabView",
    value: function archivedTabView() {
      send(Event.VIEW, 'tab_arquivadas');
    }
  }, {
    key: "allTabClick",
    value: function allTabClick() {
      send(Event.CLICK, 'tab_todas');
    }
  }, {
    key: "allTabView",
    value: function allTabView() {
      send(Event.VIEW, 'tab_todas');
    }
  }, {
    key: "tabChatClick",
    value: function tabChatClick(tab) {
      send(Event.CLICK, 'tab_chat_ad_message', tab);
    }
  }, {
    key: "prepareDataAndSend",
    value: function prepareDataAndSend(event, objectDetail) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _this$buildParamsMap = this.buildParamsMap(params),
        topLevel = _this$buildParamsMap.topLevel,
        extra = _this$buildParamsMap.extra;
      send(event, objectDetail, topLevel, extra);
    }
  }, {
    key: "prepareDataAndSendAsBeacon",
    value: function prepareDataAndSendAsBeacon(event, objectDetail) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _this$buildParamsMap2 = this.buildParamsMap(params),
        topLevel = _this$buildParamsMap2.topLevel,
        extra = _this$buildParamsMap2.extra;
      sendAsBeacon(event, objectDetail, topLevel, extra);
    }
  }, {
    key: "buildParamsMap",
    value: function buildParamsMap(_ref) {
      var _ref$chat = _ref.chat,
        chat = _ref$chat === void 0 ? this.chat : _ref$chat,
        _ref$accountId = _ref.accountId,
        accountId = _ref$accountId === void 0 ? this.accountId : _ref$accountId,
        error = _ref.error,
        params = _objectWithoutProperties(_ref, _excluded);
      var topLevelFields = ['ad_id', 'list_id', 'category_id', 'subcategory_id', 'chat_id', 'message_id', 'account_id'];
      var all = _objectSpread({
        account_id: accountId,
        mercurio_version: this.version
      }, params);
      if (error) {
        all.error = this.buildErrorData(error);
        if (error.stanza) {
          var id = error.stanza.attrs.id;
          all.packet_id = id;
        }
      }
      if (Object.keys(chat).length) {
        var roomname = chat.roomname,
          buyerId = chat.buyerId,
          sellerId = chat.sellerId,
          listId = chat.listId,
          category = chat.category;
        all = _objectSpread({
          chat_id: roomname,
          buyer_id: buyerId,
          seller_id: sellerId,
          list_id: listId,
          category_id: category
        }, all);
      }
      var response = {
        topLevel: {},
        extra: {}
      };
      Object.keys(all).forEach(function (key) {
        if (topLevelFields.includes(key)) {
          response.topLevel[key] = all[key];
        } else {
          response.extra[key] = all[key];
        }
      });
      return response;
    }
  }, {
    key: "buildErrorData",
    value: function buildErrorData(_ref2) {
      var message = _ref2.message,
        name = _ref2.name,
        inputStanza = _ref2.inputStanza,
        outputStanza = _ref2.outputStanza;
      var _this$renderProps = this.renderProps,
        user = _this$renderProps.user,
        listId = _this$renderProps.listId,
        roomname = _this$renderProps.roomname,
        resource = _this$renderProps.resource;
      return JSON.stringify({
        message: message,
        name: name,
        inputStanza: encodeURI(inputStanza),
        outputStanza: encodeURI(outputStanza),
        user: user,
        listId: listId,
        roomname: roomname,
        resource: resource
      });
    }
  }], [{
    key: "toggleNotification",
    value: function toggleNotification(chatId, enabled) {
      send(Event.CLICK, 'toggle_validating_profile_notification', {
        chat_id: chatId,
        enabled: enabled
      });
    }

    // Click on button "Pagar Agora"
  }, {
    key: "clickPayNowButton",
    value: function clickPayNowButton(listId) {
      send(Event.CLICK, 'pay_now_button', {
        listId: listId
      });
    }
  }, {
    key: "clickOrderDetailsSellerButton",
    value: function clickOrderDetailsSellerButton(listId) {
      send(Event.CLICK, 'order_details_seller_button', {
        listId: listId
      });
    }
  }, {
    key: "clickOrderDetailsBuyerButton",
    value: function clickOrderDetailsBuyerButton(listId) {
      send(Event.CLICK, 'order_details_buyer_button', {
        listId: listId
      });
    }
  }, {
    key: "loadPayNowButton",
    value: function loadPayNowButton(listId) {
      send(Event.VIEW, 'pay_now_button', {
        listId: listId
      });
    }
  }, {
    key: "loadOrderDetailsSellerButton",
    value: function loadOrderDetailsSellerButton(listId) {
      send(Event.VIEW, 'order_details_seller_button', {
        listId: listId
      });
    }
  }, {
    key: "loadOrderDetailsBuyerButton",
    value: function loadOrderDetailsBuyerButton(listId) {
      send(Event.VIEW, 'order_details_buyer_button', {
        listId: listId
      });
    }
  }, {
    key: "loadErrorPayNowButton",
    value: function loadErrorPayNowButton(listId) {
      var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown';
      send(Event.ERROR, 'pay_now_button_fail_to_load', {
        listId: listId,
        error: error
      });
    }
  }, {
    key: "quarentenaApiCall",
    value: function quarentenaApiCall(event_type) {
      var extras = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var data = {
        event_type: event_type,
        object_detail: 'request',
        object_name: 'quarentena_api'
      };
      send(Event.CLICK, 'quarentena_api', data, extras);
    }
  }, {
    key: "errorBuyerOlxPayButtons",
    value: function errorBuyerOlxPayButtons(listId, _ref3) {
      var errorType = _ref3.errorType,
        errorDescription = _ref3.errorDescription;
      var fields = {
        list_id: listId,
        olx_pay_reason: errorType,
        olx_pay_reason_description: errorDescription
      };
      send(Event.ERROR, 'olxpay_txp_buttons_buyer', fields);
    }
  }, {
    key: "errorSellerOlxPayButtons",
    value: function errorSellerOlxPayButtons(listId, _ref4) {
      var errorType = _ref4.errorType,
        errorDescription = _ref4.errorDescription;
      var fields = {
        list_id: listId,
        olx_pay_reason: errorType,
        olx_pay_reason_description: errorDescription
      };
      send(Event.ERROR, 'olxpay_txp_buttons_seller', fields);
    }
  }, {
    key: "viewOfferReviewButton",
    value: function viewOfferReviewButton(listId) {
      var topLevel = {
        list_id: listId
      };
      send(Event.VIEW, 'offer_review', topLevel);
    }
  }, {
    key: "clickOfferReviewButton",
    value: function clickOfferReviewButton(listId) {
      var topLevel = {
        list_id: listId
      };
      send(Event.CLICK, 'offer_review', topLevel);
    }
  }, {
    key: "viewMakeOfferButton",
    value: function viewMakeOfferButton(listId) {
      var topLevel = {
        list_id: listId
      };
      send(Event.VIEW, 'make_offer', topLevel);
    }
  }, {
    key: "clickMakeOfferButton",
    value: function clickMakeOfferButton(listId) {
      var topLevel = {
        list_id: listId
      };
      send(Event.CLICK, 'make_offer', topLevel);
    }
  }, {
    key: "viewTipEvent",
    value: function viewTipEvent(objectDetail, params) {
      send(Event.VIEW, objectDetail, params);
    }

    // Other events
  }, {
    key: "clickUnhideMask",
    value: function clickUnhideMask(objectDetail, params) {
      send(Event.CLICK, objectDetail, params);
    }
  }, {
    key: "clickOpenSecurityModalChat",
    value: function clickOpenSecurityModalChat(params) {
      send(Event.CLICK, 'open_security_modal_button_chat', params);
    }
  }, {
    key: "clickSeeNumberModalChat",
    value: function clickSeeNumberModalChat(params) {
      send(Event.CLICK, 'see_number_modal_button_chat', params);
    }
  }, {
    key: "clickKeepSafeInChat",
    value: function clickKeepSafeInChat(params) {
      send(Event.CLICK, 'keep_safe_modal_button_chat', params);
    }
  }, {
    key: "clickCloseModalChat",
    value: function clickCloseModalChat(params) {
      send(Event.CLICK, 'close_security_modal_button_chat', params);
    }
  }, {
    key: "errorKeepPreferencesModal",
    value: function errorKeepPreferencesModal(params) {
      send(Event.ERROR, 'error_storage_security_modal', params);
    }
  }, {
    key: "viewModalSendPhoneMessage",
    value: function viewModalSendPhoneMessage(params) {
      send(Event.VIEW, 'try_send_phone_message', params);
    }
  }, {
    key: "clickNotSendPhoneMessage",
    value: function clickNotSendPhoneMessage(params) {
      send(Event.VIEW, 'click_not_send_phone_message', params);
    }
  }, {
    key: "clickSendPhoneMessage",
    value: function clickSendPhoneMessage(params) {
      send(Event.VIEW, 'click_send_phone_message', params);
    }
  }, {
    key: "formatTextError",
    value: function formatTextError(idMessage, exception) {
      send(Event.ERROR, 'format_text', {
        message_id: idMessage,
        exception: exception
      });
    }
  }]);
}();
var _default = exports["default"] = Lurker;